<template>
    <div
        class="z-highlighted-block"
        :class="classObject">
        <slot></slot>
    </div>
</template>

<script setup>
import { computed } from 'vue'

// props
const props = defineProps({
    bg: {
        type: Boolean,
        default: false
    },
    bgDark: {
        type: Boolean,
        default: false
    },
    lineSide: {
        type: String,
        default: 'left',
        validator: (prop) => ['left', 'horizontal'].includes(prop)
    },
    line: {
        type: Boolean,
        default: true
    },
    lead: {
        type: Boolean,
        default: false
    },
    size: {
        type: String,
        default: '',
        validator: (prop) => ['m', 'l', ''].includes(prop)
    }
})

// computed
const classObject = computed(() => {
    if (props.lead) {
        return {
            'z-highlighted-block--bg-color-default': props.bg,
            'z-highlighted-block--lead': props.lead,
            [`z-highlighted-block--size-${props.size}`]: props.size,
            [`z-highlighted-block--with-line z-highlighted-block--with-line-${props.lineSide}`]:
            props.line && props.lineSide
        }
    }
    return {
        [`z-highlighted-block--size-${props.size}`]: props.size,
        'z-highlighted-block--bg-color-default': props.bg,
        'z-highlighted-block--bg-color-dark': props.bgDark,
        'z-highlighted-block--border': props.border,
        'z-highlighted-block--bold': props.bold
    }

})
</script>

<style lang="scss" src="./index.scss"></style>
